import React from "react";
import { Routes, Route, useLocation ,Navigate} from "react-router-dom";
import { initGA, isAnalyticsEnabled, logPageView } from "./utils/google_analytics";
import { useEffect } from "react";
import MainLayout from "./layouts/mainlayout";
import Home from "./pages/home";
import TournamentDetails from "./components/tournament/tournament_details";
import BlogList from "./pages/blog_list";
import BlogInfo from "./pages/blog_info";
import Store from "./pages/store";
import Tournaments from "./pages/tournaments";
import MVP from "./pages/mvp";
import CouponPreview from "./components/store/product_preview";
import LeaderBoard from "./pages/leaderboard";
import FAQ from "./pages/faq";
import EMagazines from "./pages/e_magazines";
import MyOrders from "./pages/my_orders";
import Games from "./pages/games";
import GamePlayer from "./pages/game_player";
import PrivacyPolicy from "./components/policies/privacy_policy";
import CookiePolicy from "./components/policies/cookie_policy";
import TermsAndConditions from "./components/policies/terms_and_conditions";
import CommunityGuidelines from "./components/policies/community_guidelines";
import MyAccount from "./components/myaccount/profile";
import PlacementCellRequirement from "./components/forms/placement_cell_requirements";
import StudentPresidentRequirement from "./components/forms/student_president_requirements";
import SubmitYourGame from "./components/forms/submit_game";
import RewardSponser from "./components/forms/reward_sponsor";
import Creator from "./components/creator/creator";
import CreatorDashboard from "./components/creator/creator_dashboard";
import ReferEarnDashboard from "./components/refer_earn/refer_earn";
import DeleteAccount from "./components/policies/account-deletion";
import Magazine from "./pages/magazine";
import MagazinePage from "./components/magazine/MagazinePage";
import MagazineLibrary from "./components/magazine/MagazineLibrary";
import GameJam from "./pages/gamejam";
import GameJamRegister from "./components/gamejam/gamejam_register";
import GameJamDetails from "./components/gamejam/gamejam_details";
import GameJamListing from "./components/gamejam/gamejam_listing";
import GameJamV3 from "./pages/gamejam_v3";
import GameJamWebGLHelp from "./pages/gamejam_webgl_help";
import Sandbox from "./components/gamejam/sandbox";
// import Games from "./pages/games";
import GamesDetails from "./pages/games_details";
import MediaKitDetails from "./components/media_kit/media_kit_details";
import MediaKit from "./pages/mediakit";
import MediaKitSlugDownload from "./components/media_kit/media_kit_slug";
import BlogDetail from "./pages/new_blog";
import Message from "./pages/newsletter";

function App() {
  const location = useLocation();

  useEffect(() => {
    if (isAnalyticsEnabled()) {
      initGA();
    }
  }, []);

  useEffect(() => {
    if (isAnalyticsEnabled()) {
      logPageView(`${location.pathname}${location.search}`);
    }
  }, [location.pathname, location.search]);

  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Home />} />
        <Route path="/invite/:id" element={<Home />} />
        <Route path="/tournaments/:game_id/:event_id" element={<TournamentDetails />} />
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:url" element={<BlogInfo />} />
        <Route path="/e-magazines" element={<EMagazines />} />
        <Route path="/games" element={<Games />} />
        <Route path="/games/:slug" element={<GamePlayer />} />
        <Route path="/store" element={<Store />} />
        <Route path="/my-orders" element={<MyOrders/>}/>
        <Route path="/purchase" element={<CouponPreview />} />
        <Route path="/tournaments" element={<Tournaments />} />
        <Route path="/leaderboard" element={<LeaderBoard />} />
        <Route path="/mvp_v1" element={<MVP />} />
        <Route path="/faq" element={<FAQ />} />

        {/* Policies */}
        <Route path='/privacy-policy' element={<PrivacyPolicy/>} />
        <Route path='/cookie-policy' element={<CookiePolicy/>} />
        <Route path='/terms-and-conditions' element={<TermsAndConditions/>} />
        <Route path='/community-guidelines' element={<CommunityGuidelines/>} />
        
        {/* Forms */}
        <Route path='/placement-cell-requirement' element={<PlacementCellRequirement />} />
        <Route path='/student-president-requirement' element={<StudentPresidentRequirement />} />
        <Route path='/submit-game' element={<SubmitYourGame />} />
        <Route path='/become-sponsor' element={<RewardSponser />} />

        {/* message Route */}
        <Route path="/newsletter" element={<Message />} />
        <Route path="/new-blog" element={<BlogDetail />} />

        <Route path="/profile" element={<MyAccount />} />
        <Route path='/creator' element={<Creator/>} />
        <Route path="/creator-admin" element={<CreatorDashboard/>} />
        <Route path="/refer-earn" element={<ReferEarnDashboard/>} />
        <Route path="/delete-account" element={<DeleteAccount/>} />
        <Route path="/magazine" element={<Magazine />} />
        <Route path="/magazine/library" element={<MagazineLibrary />} />
        <Route path="/magazine/read/:article" element={<MagazinePage />} />

        {/* GAMEJAM SECTION */}
        <Route path="/gamejam_v1" element={<GameJamV3/>} />
        <Route path="/gamejam_v1/webgl-help" element={<GameJamWebGLHelp/>} />
        <Route path="/gamejam_v1/sandbox" element={<Sandbox/>} />
        <Route path="/gamejam_v1-register" element={<GameJamRegister/>} />
        <Route path="/gamejam_v1-details/:sub_id" element={<GameJamDetails/>} />
        <Route path="/gamejam_v1-listing" element={<GameJamListing/>} />

        {/* MEDIA-KIT SECTION */}
        <Route path="/media-kit" element={<MediaKit />} />
        <Route path="/media-kit/:kitId/:slug" element={<MediaKitSlugDownload />} />
        <Route path="/media-kit/:kitId" element={<MediaKitDetails />} />

        {/* GAMES DISTRIBUTION */}
        <Route path="/games" element={<Games />} />
        <Route path="/games/:slug" element={<GamesDetails />} />
      </Route>
    </Routes>
  );
}

export default App;
